import { Printer } from "../types/printer";
import { createApiStore } from "./genericStore";
import api from "../service/api";

const baseStore = createApiStore<Printer>("/printer");

// Arayüze özel bir fonksiyon eklemek için:
export const usePrinterStore = () => {
  const store = baseStore();

  const testConnection = async (printerId: number) => {
    // Örnek: Yazıcıya bir test verisi gönder
    return await api.post(`/printer/${printerId}/test`);
  };

  const printPreview = async (payload: { category: string; templateId: string | number; printerId: string | number; entityId?: number | string; customData?: any }) => {
    const res = await api.post("/print/preview", payload);
    return res.data;
  };

  const printRaw = async (payload: { printerIp: string; data: string }) => {
    const res = await api.post("/print/raw", payload);
    return res.data;
  };

  const getPrintPayload = async (payload: { category: string; entityId?: number | string; customData?: any }) => {
    const res = await api.post("/print/payload", payload);
    return res.data;
  };

  const getPreviewJson = async (payload: { category: string; templateId: string | number; printerId: string | number; entityId?: number | string; customData?: any }) => {
    const res = await api.post("/print/preview-json", payload);
    return res.data;
  };

  return {
    ...store,
    testConnection,
    printPreview,
    printRaw,
    getPrintPayload,
    getPreviewJson
  };
};